import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PlugAndPlayDragModel } from "src/app/models/plugAndPlay.model";
import { PlugAndPlayService } from "src/app/services/plugandplay.service";
import { MsalService } from "@azure/msal-angular";
import { Sharedservice } from "src/app/shared-components/shared.service";
import {
  MessageService,
  ConfirmationService,
  LazyLoadEvent,
} from "primeng/api";
import {
  severitymessage,
  EngagementDetailMessage,
  FunctionalityNames,
  LanguageConstants,
} from "src/app/shared-components/constant";
import { InfraService } from "src/app/services/infra.service";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { EngagementService } from "src/app/services/engagement.service";
import { max } from "moment";
import { RegionModel } from "src/app/models/region.model";
import { RegionService } from "src/app/services/region.service";
import { CustomizedLayoutService } from "src/app/services/customized-layout.service";
import { forkJoin, retry } from "rxjs";
import { CustomLayoutModel } from "src/app/models/custom-layout.model";
import { environment } from "src/environments/environment";
import { UserService } from "src/app/services/user.service";
import { MasterLanguage } from "../../models/MasterLanguage.model";
import { UserModel } from "src/app/models/user.model";

@Component({
  selector: 'app-customized-layouts',
  templateUrl: './customized-layouts.component.html',
  styleUrls: ['./customized-layouts.component.css']
})
export class CustomizedLayoutsComponent implements OnInit {
  selectedValue: string;
  engagementId = +this.route.snapshot.paramMap.get("id");
  cols: any[];
  bsCols: any[];
  counter: number = 0;

  nextStep: any;
  //previousStep: any;

  plugandplayDataPL: CustomLayoutModel[] = [];
  plugandplayDataBS: CustomLayoutModel[] = [];

  plugandplayDataNewPL: CustomLayoutModel[] = [];
  plugandplayDataNewBS: CustomLayoutModel[] = [];

  plugandplayDataDeletedPL: CustomLayoutModel[] = [];
  plugandplayDataDeletedBS: CustomLayoutModel[] = [];

  plugandplayDataAddBacksPL: CustomLayoutModel[] = [];
  plugandplayDataAddBacksBS: CustomLayoutModel[] = [];

  plugandplayAddbackPL: CustomLayoutModel[] = [];
  plugandplayData: CustomLayoutModel[] = [];
  activePlugandPlaySubtotalIds: string[] = [];
  inactivePlugandPlaySubtotalIds: string[] = [];

  currLangTranslation: any;
  isDivReadonly: boolean = true;
  index: number = 0;
  divModifyFirst: boolean = true;
  divModifySecound: boolean = false;

  frozenCols: any[];
  scrollableCols: any[];
  maxSmId: number = 0;
  maxSubtotalID: number = 0;
  //maxBSSmId: number = 0;
  langCode: string;
  isNextButtonDisable = false;
  normalConfirmKeyDelete = "normalDelete";
  normalConfirmKeyDelete2 = "normalDelete2";

  plugAndPlayData: CustomLayoutModel[] = [];
  disableCustomSubtotal: boolean = false;

  loadspinner = false;

  activeIndex: number = 0;
  isMaximized: boolean = false;

  templateId: number;

  addBackRow: CustomLayoutModel[] = [];

  isUpdated: boolean = false;
  isSaved: boolean = false;
  nextClick: boolean = false;
  isCustomizedEngagement: boolean = false;
  balanceSheetGroupData: any[] = [];
  addBacksLabel: string;
  regionId: number;
  display: boolean = false;
  templateList = [];
  selectedTemplate: string = "0";
  isCreateLayoutClicked: boolean = false;
  loggedInUserId: number;
  userEmail: any;
  isDataLoaded: boolean = false;
  isSaveAsclicked: boolean = false;
  layoutName: string | null;
  isValidLayoutName: boolean = true;
  isValidLayoutNameLength: boolean = true;
  isDuplicateLayoutName: boolean = false;
  customTemplateList: any[] = [];
  customTemplatesWithoutSharedLayout: any[] = [];
  selectedCustomTemplate: string = "0";
  enableSaveAndDelete: boolean = false;
  SubtotalIds = [
    { key: 1, value: 'A' },
    { key: 2, value: 'B' },
    { key: 3, value: 'C' },
    { key: 4, value: 'D' },
    { key: 5, value: 'E' },
    { key: 6, value: 'F' },
    { key: 7, value: 'G' },
    { key: 8, value: 'H' },
    { key: 9, value: 'I' },
    { key: 10, value: 'J' },
    { key: 11, value: 'K' },
    { key: 12, value: 'L' },
    { key: 13, value: 'M' },
    { key: 14, value: 'N' },
    { key: 15, value: 'O' },
    { key: 16, value: 'P' },
    { key: 17, value: 'Q' },
    { key: 18, value: 'R' },
    { key: 19, value: 'S' },
    { key: 20, value: 'T' },
    { key: 21, value: 'U' },
    { key: 22, value: 'V' },
    { key: 23, value: 'W' },
    { key: 24, value: 'X' },
    { key: 25, value: 'Y' },
    { key: 26, value: 'Z' },
    { key: 27, value: 'AA' },
    { key: 28, value: 'BB' },
    { key: 29, value: 'CC' },
    { key: 30, value: 'DD' },
    { key: 31, value: 'EE' },
    { key: 32, value: 'FF' },
    { key: 33, value: 'GG' },
    { key: 34, value: 'HH' },
    { key: 35, value: 'II' },
    { key: 36, value: 'JJ' },
    { key: 37, value: 'KK' },
    { key: 38, value: 'LL' },
    { key: 39, value: 'MM' },
    { key: 40, value: 'NN' },
    { key: 41, value: 'OO' },
    { key: 42, value: 'PP' },
    { key: 43, value: 'QQ' },
    { key: 44, value: 'RR' },
    { key: 45, value: 'SS' },
    { key: 46, value: 'TT' },
    { key: 47, value: 'UU' },
    { key: 48, value: 'VV' },
    { key: 49, value: 'WW' },
    { key: 50, value: 'XX' },
    { key: 51, value: 'YY' },
    { key: 52, value: 'ZZ' },
  ]
  remainingSubtotalIds: any[] = [];
  deletedSubtotalIds: any[] = [];
  environment: string;
  languages: MasterLanguage[];
  selectedLanguageId: string = "0";
  isShareClicked: boolean = false;
  UsersList: any;
  results: any;
  isValidEmailId: boolean = true;
  Users: any = [];
  isShareButtonDisabled: boolean = false;
  isSharedLayout: boolean = false;
  BaseLayout: string = "";
  constructor(
    private infraService: InfraService,
    private router: Router,
    private plugAndPlayService: PlugAndPlayService,
    private route: ActivatedRoute,
    private adalSvc: MsalService,
    private messageService: MessageService,
    private translateService: TranslateService,
    public sharedService: Sharedservice,
    private confirmationService: ConfirmationService,
    private engagementService: EngagementService,
    private regionService: RegionService,
    private customizedLayoutService: CustomizedLayoutService,
    private userService: UserService

  ) {
    this.loggedInUserId = +localStorage.getItem("loggedInUserId");
    this.userService.captureUserProfile().subscribe(userData => {
      this.userEmail = userData[0].UPN;
    })
    this.infraService.infraDetails$.subscribe((data) => {
      if (data !== undefined) {
        this.regionId = data.InfraId;
      }
    });
  }

  ngOnInit() {
    this.environment = environment.env;
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.messageService.clear("myKey1");
    this.getTemplates(this.regionId);
    this.getCustomTemplates(this.loggedInUserId);
    this.GetAllActiveLanguages();
    this.GetAllUsers();
    this.activeIndex =
      +this.sharedService.getLocalStorageValueByName("activeindex");
    this.normalConfirmKeyDelete = "normalDelete";
    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {

        this.langCode = langEvent.lang;
        this.currLangTranslation = langEvent.translations;
        this.bsCols = [
          // { field: 'id', header: 'Id' },
          {
            field: "smId",
            header: this.currLangTranslation.plugAndPlay.MappingId,
            isFrozenColumn: true,
            editable: false,
          }, //TODO smid
          {
            field: "subTotalId",
            header: this.currLangTranslation.plugAndPlay.SubtotalId,
            isFrozenColumn: true,
            editable: false,
          },
          {
            field: "mappingOrder",
            header: this.currLangTranslation.plugAndPlay.MappingOrder,
            isFrozenColumn: true,
            editable: false,
          },
          {
            field: "standardizedMapping",
            header: this.currLangTranslation.plugAndPlay.StandardizedMapping,
            isFrozenColumn: true,
            editable: true,
          },
          {
            field: "tagging",
            header: this.currLangTranslation.plugAndPlay.BalanceSheetGroup,
            isFrozenColumn: false,
            editable: true,
          },
          {
            field: "operation",
            header: this.currLangTranslation.plugAndPlay.Operation,
            isFrozenColumn: false,
            editable: true,
          },
        ];

        this.cols = [
          // { field: 'id', header: 'Id' },
          {
            field: "smId",
            header: this.currLangTranslation.plugAndPlay.MappingId,
            isFrozenColumn: true,
            editable: false,
          }, //TODO smid
          {
            field: "subTotalId",
            header: this.currLangTranslation.plugAndPlay.SubtotalId,
            isFrozenColumn: true,
            editable: false,
          },
          {
            field: "mappingOrder",
            header: this.currLangTranslation.plugAndPlay.MappingOrder,
            isFrozenColumn: true,
            editable: false,
          },
          {
            field: "standardizedMapping",
            header: this.currLangTranslation.plugAndPlay.StandardizedMapping,
            isFrozenColumn: true,
            editable: true,
          },
          {
            field: "operation",
            header: this.currLangTranslation.plugAndPlay.Operation,
            isFrozenColumn: false,
            editable: true,
          },
        ];
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
      }
    );

    this.bsCols = [
      // { field: 'id', header: 'Id' },
      {
        field: "smId",
        header: this.currLangTranslation.plugAndPlay.MappingId,
        isFrozenColumn: true,
        editable: false,
      }, //TODO smid
      {
        field: "subTotalId",
        header: this.currLangTranslation.plugAndPlay.SubtotalId,
        isFrozenColumn: true,
        editable: false,
      },
      {
        field: "mappingOrder",
        header: this.currLangTranslation.plugAndPlay.MappingOrder,
        isFrozenColumn: true,
        editable: false,
      },
      {
        field: "standardizedMapping",
        header: this.currLangTranslation.plugAndPlay.StandardizedMapping,
        isFrozenColumn: true,
        editable: true,
      },
      {
        field: "tagging",
        header: this.currLangTranslation.plugAndPlay.BalanceSheetGroup,
        isFrozenColumn: false,
        editable: true,
      },
      {
        field: "operation",
        header: this.currLangTranslation.plugAndPlay.Operation,
        isFrozenColumn: false,
        editable: true,
      },
    ];

    this.cols = [
      // { field: 'id', header: 'Id' },
      {
        field: "smId",
        header: this.currLangTranslation.plugAndPlay.MappingId,
        isFrozenColumn: true,
        editable: false,
      }, //TODO smid
      {
        field: "subTotalId",
        header: this.currLangTranslation.plugAndPlay.SubtotalId,
        isFrozenColumn: true,
        editable: false,
      },
      {
        field: "mappingOrder",
        header: this.currLangTranslation.plugAndPlay.MappingOrder,
        isFrozenColumn: true,
        editable: false,
      },
      {
        field: "standardizedMapping",
        header: this.currLangTranslation.plugAndPlay.StandardizedMapping,
        isFrozenColumn: true,
        editable: true,
      },
      {
        field: "operation",
        header: this.currLangTranslation.plugAndPlay.Operation,
        isFrozenColumn: false,
        editable: true,
      },
    ];

    this.nextStep = this.currLangTranslation.actionButtons.nextStep;
    // this.previousStep = this.currLangTranslation.actionButtons.previousStep;
  }

  trackCounter(index: number, elem: any): number {
    this.counter = index + 1;
    return this.counter;
  }

  onBaseLayoutChange(value) {
    if (value == "0") {
      this.plugandplayDataNewPL = [];
      this.plugandplayDataNewBS = [];
      this.plugandplayDataAddBacksPL = [];
      this.selectedLanguageId = "0";
    }
  }

  GetCustomizedLayoutData(templateId, language) {
    //var layoutName = this.selectedCustomTemplate;
    this.templateId = Number(this.selectedTemplate);
    this.isSharedLayout = this.selectedCustomTemplate.includes('shared') ? true : false;
    
    this.isShareButtonDisabled = this.selectedCustomTemplate.includes('shared') ? true : false;
    this.BaseLayout = (this.customTemplateList.find(x=>x.layoutName == this.selectedCustomTemplate)?.templateId == 1) ? 'Americas' : 'ROW';

    if (this.selectedCustomTemplate != "0") {
      this.selectedLanguageId = this.customTemplateList.find(x => x.layoutName == this.selectedCustomTemplate)?.languageId;
    }

    if (language == "0" && this.selectedCustomTemplate == "0") {
      this.enableSaveAndDelete = false;
      this.plugandplayDataNewPL = [];
      this.plugandplayDataNewBS = [];
      this.plugandplayDataAddBacksPL = [];
      this.selectedLanguageId = "0";
      return;
    }
    if (this.selectedCustomTemplate != "0") {
      this.enableSaveAndDelete = true;
    }
    this.loadspinner = true;
    this.plugandplayDataDeletedBS = [];
    this.plugandplayDataDeletedPL = [];
    this.addBackRow = [];
    this.templateId = this.templateId != null ? this.templateId : 0;
    this.remainingSubtotalIds = [];
    this.deletedSubtotalIds = [];

    const getCustomizedLayoutByUserId = this.customizedLayoutService
      .getCustomizedLayoutByUserId(this.loggedInUserId, this.templateId, this.selectedCustomTemplate, language);


    const getBalanceSheetGroupForUserLayout = this.customizedLayoutService
      .GetBalanceSheetGroupForUserLayout(language, this.selectedCustomTemplate);

    const getLayoutNames = this.customizedLayoutService
      .GetLayoutNames(this.loggedInUserId);

    forkJoin([getCustomizedLayoutByUserId, getBalanceSheetGroupForUserLayout, getLayoutNames]).subscribe(([response, response2, response3]) => {
      this.loadspinner = false;
      this.plugandplayDataPL = response.message.filter(
        (x) =>
          x.mapping == "PL" && x.isDeleted == false && x.isAddback === false
      );

      this.balanceSheetGroupData = response2;
      this.customTemplateList = response3;
      var sharedTemplateList = response3.filter(x => x.layoutName.includes('shared'));
      this.customTemplatesWithoutSharedLayout = this.customTemplateList.filter(item=> !sharedTemplateList.includes(item));

      // var sharedTemplateList = this.customTemplateList.filter(x=>x.layoutName.includes('shared'));
      // const result = response3.filter(item1 => 
      //   !sharedTemplateList.some(item2 => item2.layoutName === item1.layoutName)
      // );

      this.plugandplayDataBS = response.message.filter((x) => x.mapping == "BS");
      this.plugandplayDataPL.forEach(x => {
        x.isDeletable = x.header_English === "Revenue" || x.header_English === "Net revenue" || x.header_English === "Net income / (loss)" || x.header_English === "Operating expense" ? false : true;
        x.isEditable = x.header_English === "Net revenue" ? false : true;
      });

      this.plugandplayDataBS.forEach(x => {
        x.isDeletable = x.isEditable = x.header_English === "Equity" && x.smId !== "" ? false : true;
      });

      this.plugandplayDataAddBacksPL = response.message.filter(
        (x) => x.isAddback === true
      );

      this.addBacksLabel = this.plugandplayDataAddBacksPL.length > 0 ? this.plugandplayDataAddBacksPL.find(x => x.smId === "-2").standardizedMapping : "";

      this.plugandplayDataAddBacksPL.forEach(x => {
        x.isEditable = x.smId === "" ? false : true;
      });

      this.templateId = this.plugandplayDataPL[0].templateId;

      let indexToRemove = this.plugandplayDataAddBacksPL.findIndex(
        (item) => item.smId === "-2" //for add backs
      );

      let row$ = this.plugandplayDataAddBacksPL[indexToRemove];
      this.addBackRow.push(row$);

      if (indexToRemove != -1)
        this.plugandplayDataAddBacksPL.splice(indexToRemove, 1);

      this.plugAndPlayData = response.message.filter(x => x.isDeleted == false && x.isAddback === false);

      this.maxSmId = this.plugAndPlayData[0]["maxId"];

      this.maxSubtotalID = this.plugAndPlayData[0]["maxSubTotalId"];

      this.disableCustomSubtotal = this.maxSubtotalID == 52 ? true : false;

      response.message[0].subtotalIds.forEach(x => {
        this.remainingSubtotalIds.push(x.subtotalId);
      });

      this.plugandplayDataNewPL = [...this.plugandplayDataPL];
      this.plugandplayDataNewBS = [...this.plugandplayDataBS];
      this.isDataLoaded = false;
      this.isDivReadonly = false;
      this.loadspinner = false;
      this.divModifySecound = true;
      this.plugandplayDataDeletedBS = [];
      this.plugandplayDataDeletedPL = [];
    });

  }


  reject() {
    this.display = false;
    this.plugandplayDataDeletedBS = [];
    this.plugandplayDataDeletedPL = [];
    this.plugAndPlayService
      .getPlugAndPlayPLByEngagementId(this.engagementId.toString())
      .subscribe((data: any) => {
        this.plugandplayDataPL = data.message.filter(
          (x) =>
            x.mapping == "PL" &&
            x.isDeleted == false &&
            x.isAddback === false
        );

        this.plugAndPlayData = data.message.filter(x => x.isDeleted == false && x.isAddback === false);

        this.plugandplayDataAddBacksPL = data.message.filter(
          (x) => x.isAddback === true
        );
        this.templateId = this.plugandplayDataPL[0].templateId;

        let indexToRemove = this.plugandplayDataAddBacksPL.findIndex(
          (item) => item.smId === "-2"
        );

        let row$ = this.plugandplayDataAddBacksPL[indexToRemove];
        this.addBackRow.push(row$);

        if (indexToRemove != -1)
          this.plugandplayDataAddBacksPL.splice(indexToRemove, 1);

        this.maxSmId = this.plugAndPlayData[0]["maxId"];

        this.maxSubtotalID = this.plugAndPlayData[0]["maxSubTotalId"];

        this.disableCustomSubtotal = this.maxSubtotalID == 52 ? true : false;

        var activePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == false);
        activePlugAndPlayDataForSubtotals.forEach(item => {
          this.activePlugandPlaySubtotalIds.push(
            item.subTotalId
          )
        });

        var inActivePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == true);
        inActivePlugAndPlayDataForSubtotals.forEach(item => {
          this.inactivePlugandPlaySubtotalIds.push(
            item.subTotalId
          )
        });

        //this.maxBSSmId = this.plugandplayDataPL[0]["maxBSId"];

        this.plugandplayDataBS = data.message.filter(
          (x) => x.mapping == "BS"
        );

        this.plugandplayDataNewPL = [...this.plugandplayDataPL];
        this.plugandplayDataNewBS = [...this.plugandplayDataBS];
        this.loadspinner = false;
        this.plugandplayDataDeletedBS = [];
        this.plugandplayDataDeletedPL = [];
        this.router.navigate([
          "/engagement/",
          this.engagementId,
          "uploaddownloadflatfile",
        ]);
      });

  }

  cancel() {
    this.display = false;
    this.nextClick = false;
    this.Users = [];
  }

  cancelLayoutNamePopUp() {
    this.isSaveAsclicked = false;
  }

  cancelSharePopUp() {
    this.isShareClicked = false;
  }


  addToAddBacksPL(row) {
    this.plugandplayDataAddBacksPL.push(row);
  }

  addToAddBacksPLBlank() {
    this.addCustomStdMappingPL();
  }

  addNewAddBack(row, rowIndex) {
    this.isUpdated = true;
    var plugAndPlay: CustomLayoutModel = {
      Id: 1,
      smId: "00",
      Mapping: "PL",
      SequenceNumber: 1,
      SortOrder: 1,
      standardizedMapping: "",
      isBold: false,
      EngagementId: this.engagementId,
      operation: "",
      IsNew: true,
      IsSubTotal: false,
      IsCustom: true,
      maxId: this.maxSmId + 1,
      isDeleted: false,
      isAddback: true,
      mappingOrder: false,
      isSelected: false,
      templateId: this.templateId,
      tagging: "",
      tagging_English: "",
      header_English: "",
      isDeletable: true,
      isEditable: true,
      subTotalId: "",
      user_Operation: "",
      userId: 0,
      layoutName: "",
      subtotalIds: [],
      isDuplicateMappingIdsInSubtotal: false,
      isMandatoryFieldEmpty: false
    };

    this.plugandplayDataAddBacksPL.splice(rowIndex + 1, 0, plugAndPlay);
  }

  deleteRowAddbacksPL(row) {


    //this.plugandplayDataAddBacksPL.push(row);
    this.confirmationService.confirm({
      key: this.normalConfirmKeyDelete,
      message: this.currLangTranslation.plugAndPlay.WarningMessage6,
      header: this.currLangTranslation.labels.warning,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {
        this.loadspinner = true;

        //TODO need to do this.
        this.plugandplayDataAddBacksPL.splice(
          this.plugandplayDataAddBacksPL.indexOf(row),
          1
        );
        this.isUpdated = true;
        this.loadspinner = false;
      },
      reject: () => { },
    });
  }

  deleteRowPL(row) {
    var plugAndPlay: CustomLayoutModel = {
      Id: 1,
      smId: "00",
      Mapping: "PL",
      SequenceNumber: 1,
      SortOrder: 1,
      standardizedMapping: "",
      isBold: false,
      EngagementId: this.engagementId,
      operation: "",
      IsNew: true,
      IsSubTotal: false,
      IsCustom: true,
      maxId: this.maxSmId + 1,
      //maxBSId: this.maxBSSmId + 1,
      isDeleted: false,
      isAddback: true,
      mappingOrder: false,
      isSelected: false,
      templateId: this.templateId,
      tagging: "",
      tagging_English: "",
      header_English: "",
      isDeletable: true,
      isEditable: true,
      subTotalId: "",
      user_Operation: "",
      userId: 0,
      layoutName: "",
      subtotalIds: [],
      isDuplicateMappingIdsInSubtotal: false,
      isMandatoryFieldEmpty: false
    };
    var message =
      row.smId == ""
        ? this.currLangTranslation.plugAndPlay.WarningMessage2
        : this.currLangTranslation.plugAndPlay.WarningMessage1;
    this.confirmationService.confirm({
      key: this.normalConfirmKeyDelete,
      message: message,
      header: this.currLangTranslation.labels.warning,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {
        this.loadspinner = true;
        this.isUpdated = true;
        if (this.templateId === 1) {
          var deleteDandACogs = this.plugandplayDataNewPL.find(
            (x) => x.smId == "8"
          );
          var deleteDandAOpex = this.plugandplayDataNewPL.find(
            (x) => x.smId == "24"
          );
          var deleteDandAOtherExpense = this.plugandplayDataNewPL.find(
            (x) => x.smId == "25"
          );
          this.plugandplayDataNewPL.splice(
            this.plugandplayDataNewPL.indexOf(row),
            1
          );
          if (row.smId == "3") {
            if (deleteDandACogs) {
              this.plugandplayDataNewPL.splice(
                this.plugandplayDataNewPL.indexOf(deleteDandACogs),
                1
              );
              this.plugandplayDataDeletedPL.push(row);
              this.plugandplayDataDeletedPL.push(deleteDandACogs);
              this.plugandplayDataDeletedPL.forEach((x) => {
                x.isDeleted = true;
              });
            }
          } else if (row.smId == "4") {
            if (deleteDandAOpex) {
              this.plugandplayDataNewPL.splice(
                this.plugandplayDataNewPL.indexOf(deleteDandAOpex),
                1
              );
              this.plugandplayDataDeletedPL.push(row);
              this.plugandplayDataDeletedPL.push(deleteDandAOpex);
              this.plugandplayDataDeletedPL.forEach((x) => {
                x.isDeleted = true;
              });
            }
          } else if (row.smId == "5") {
            if (deleteDandAOtherExpense) {
              this.plugandplayDataNewPL.splice(
                this.plugandplayDataNewPL.indexOf(deleteDandAOtherExpense),
                1
              );
              this.plugandplayDataDeletedPL.push(row);
              this.plugandplayDataDeletedPL.push(deleteDandAOtherExpense);
              this.plugandplayDataDeletedPL.forEach((x) => {
                x.isDeleted = true;
              });
            }
          }

          else {
            this.plugandplayDataDeletedPL.push(row);
            this.plugandplayDataDeletedPL[
              this.plugandplayDataDeletedPL.indexOf(row)
            ].isDeleted = true;
          }
        } else if (this.templateId === 2) {
          var deleteDandACogs = this.plugandplayDataNewPL.find(
            (x) => x.smId == "34"
          );
          var deleteDandAOpex = this.plugandplayDataNewPL.find(
            (x) => x.smId == "48"
          );
          var deleteDandAOtherExpense = this.plugandplayDataNewPL.find(
            (x) => x.smId == "49"
          );
          this.plugandplayDataNewPL.splice(
            this.plugandplayDataNewPL.indexOf(row),
            1
          );
          if (row.smId == "29") {
            if (deleteDandACogs) {
              this.plugandplayDataNewPL.splice(
                this.plugandplayDataNewPL.indexOf(deleteDandACogs),
                1
              );
              this.plugandplayDataDeletedPL.push(row);
              this.plugandplayDataDeletedPL.push(deleteDandACogs);
              this.plugandplayDataDeletedPL.forEach((x) => {
                x.isDeleted = true;
              });
            }
          } else if (row.smId == "30") {
            if (deleteDandAOpex) {
              this.plugandplayDataNewPL.splice(
                this.plugandplayDataNewPL.indexOf(deleteDandAOpex),
                1
              );
              this.plugandplayDataDeletedPL.push(row);
              this.plugandplayDataDeletedPL.push(deleteDandAOpex);
              this.plugandplayDataDeletedPL.forEach((x) => {
                x.isDeleted = true;
              });
            }
          } else if (row.smId == "31") {
            if (deleteDandAOtherExpense) {
              this.plugandplayDataNewPL.splice(
                this.plugandplayDataNewPL.indexOf(deleteDandAOtherExpense),
                1
              );
              this.plugandplayDataDeletedPL.push(row);
              this.plugandplayDataDeletedPL.push(deleteDandAOtherExpense);
              this.plugandplayDataDeletedPL.forEach((x) => {
                x.isDeleted = true;
              });
            }
          }
          // else if (
          //   row.standardizedMapping === "Depreciation and Amortization"
          // ) {
          //   this.plugandplayDataNewPL.splice(
          //     this.plugandplayDataNewPL.indexOf(deleteDandACogs),
          //     1
          //   );
          //   this.plugandplayDataNewPL.splice(
          //     this.plugandplayDataNewPL.indexOf(deleteDandAOpex),
          //     1
          //   );
          //   this.plugandplayDataNewPL.splice(
          //     this.plugandplayDataNewPL.indexOf(deleteDandAOtherExpense),
          //     1
          //   );
          //   this.plugandplayDataDeletedPL.push(row);
          //   this.plugandplayDataDeletedPL.push(deleteDandACogs);
          //   this.plugandplayDataDeletedPL.push(deleteDandAOpex);
          //   this.plugandplayDataDeletedPL.push(deleteDandAOtherExpense);
          //   this.plugandplayDataDeletedPL.forEach((x) => {
          //     x.isDeleted = true;
          //   });
          // } 
          else {
            this.plugandplayDataDeletedPL.push(row);
            this.plugandplayDataDeletedPL[
              this.plugandplayDataDeletedPL.indexOf(row)
            ].isDeleted = true;
          }
        }

        this.plugandplayDataDeletedPL.forEach((item) => {
          var index = this.plugandplayDataAddBacksPL.findIndex(
            (x) => x.smId === item.smId && item.smId != ""
          );
          if (index != -1) {
            this.plugandplayDataAddBacksPL.splice(index, 1, plugAndPlay);
          }
        });

        var subtotalsPL = this.plugandplayDataNewPL.filter(x => x.smId == "");
        var subtotalsBS = this.plugandplayDataNewBS.filter(x => x.smId == "");

        this.plugAndPlayData = [...subtotalsPL, ...subtotalsBS, ...this.plugandplayDataAddBacksPL];
        this.disableCustomSubtotal = this.plugAndPlayData.length == 52 ? true : false;

        this.deletedSubtotalIds = [...this.deletedSubtotalIds, row.subTotalId];
        this.inactivePlugandPlaySubtotalIds = [...this.inactivePlugandPlaySubtotalIds, row.subTotalId];
        this.loadspinner = false;
      },
      reject: () => { },
    });
  }

  deleteRowBS(row) {
    var message =
      row.smId == ""
        ? this.currLangTranslation.plugAndPlay.WarningMessage2
        : this.currLangTranslation.plugAndPlay.WarningMessage1;
    this.confirmationService.confirm({
      key: this.normalConfirmKeyDelete,
      message: message,
      header: this.currLangTranslation.labels.warning,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {
        this.loadspinner = true;
        this.isUpdated = true;
        this.plugandplayDataNewBS.splice(
          this.plugandplayDataNewBS.indexOf(row),
          1
        );

        this.plugandplayDataDeletedBS.push(row);
        this.plugandplayDataDeletedBS[
          this.plugandplayDataDeletedBS.indexOf(row)
        ].isDeleted = true;

        var subtotalsPL = this.plugandplayDataNewPL.filter(x => x.smId == "");
        var subtotalsBS = this.plugandplayDataNewBS.filter(x => x.smId == "");

        this.plugAndPlayData = [...subtotalsPL, ...subtotalsBS, ...this.plugandplayDataAddBacksPL];
        this.disableCustomSubtotal = this.plugAndPlayData.length == 52 ? true : false;

        this.deletedSubtotalIds = [...this.deletedSubtotalIds, row.subTotalId];
        this.inactivePlugandPlaySubtotalIds = [...this.inactivePlugandPlaySubtotalIds, row.subTotalId];
        this.loadspinner = false;
      },
      reject: () => { },
    });
  }

  handleChange(e) {
    this.getLockButton();
    this.divModifyFirst = true;
    this.divModifySecound = true;
    this.isDivReadonly = true;
    this.index = e.index;
    if (this.plugandplayDataNewPL.length > 0 || this.plugandplayDataNewBS.length > 0) {
      this.isDivReadonly = false;
    }

  }

  onDataTableChange(event) { }

  getLockButton() {
    if (this.isDivReadonly) return "fa fa-lock";
    else return "fa fa-unlock";
  }

  addCustomStdMappingPL() {
    this.isUpdated = true;
    var plugAndPlay: CustomLayoutModel = {
      Id: 1,
      smId: (this.maxSmId + 1).toString(),
      Mapping: "PL",
      SequenceNumber: 1,
      SortOrder: 1,
      standardizedMapping: "",
      isBold: false,
      EngagementId: this.engagementId,
      operation: "",
      IsNew: true,
      IsSubTotal: false,
      IsCustom: true,
      maxId: this.maxSmId + 1,
      //maxBSId: this.maxBSSmId + 1,
      isDeleted: false,
      isAddback: false,
      mappingOrder: false,
      isSelected: false,
      templateId: this.templateId,
      tagging: "",
      tagging_English: "",
      header_English: "",
      isDeletable: true,
      isEditable: true,
      subTotalId: "",
      user_Operation: "",
      userId: 0,
      layoutName: "",
      subtotalIds: [],
      isDuplicateMappingIdsInSubtotal: false,
      isMandatoryFieldEmpty: false
    };

    this.maxSmId = this.maxSmId + 1;
    //this.maxBSSmId = this.maxBSSmId + 1;
    this.plugandplayDataNewPL = [...this.plugandplayDataNewPL, plugAndPlay];
  }

  addCustomStdMappingBS() {
    this.isUpdated = true;
    var plugAndPlay: CustomLayoutModel = {
      Id: 1,
      smId: (this.maxSmId + 1).toString(),
      Mapping: "BS",
      SequenceNumber: 1,
      SortOrder: 1,
      standardizedMapping: "",
      isBold: false,
      EngagementId: this.engagementId,
      operation: "",
      IsNew: true,
      IsSubTotal: false,
      IsCustom: true,
      maxId: this.maxSmId + 1,
      //maxBSId: this.maxBSSmId + 1,
      isDeleted: false,
      isAddback: false,
      mappingOrder: false,
      isSelected: false,
      templateId: this.templateId,
      tagging: "",
      tagging_English: "",
      header_English: "",
      isDeletable: true,
      isEditable: true,
      subTotalId: "",
      user_Operation: "",
      userId: 0,
      layoutName: "",
      subtotalIds: [],
      isDuplicateMappingIdsInSubtotal: false,
      isMandatoryFieldEmpty: false
    };
    //this.maxPLSmId = this.maxPLSmId + 1;
    this.maxSmId = this.maxSmId + 1;
    this.plugandplayDataNewBS = [...this.plugandplayDataNewBS, plugAndPlay];
  }

  addCustomStdTotalMappingPL() {
    this.isUpdated = true;
    var maxsubId = "";
    var subtotalIdsData = this.remainingSubtotalIds.length > 0 ? this.remainingSubtotalIds : this.deletedSubtotalIds;
    subtotalIdsData.sort((a, b) => {
      if (a.length === b.length) {
        return a.localeCompare(b);
      }

      return a.length - b.length;
    });

    maxsubId = subtotalIdsData[0];

    if (this.remainingSubtotalIds.length > 0) {
      this.remainingSubtotalIds.splice(subtotalIdsData.indexOf[maxsubId], 1);
    }
    else {
      this.deletedSubtotalIds.splice(subtotalIdsData.indexOf[maxsubId], 1);
    }


    var plugAndPlay: CustomLayoutModel = {
      Id: 1,
      smId: "",
      Mapping: "PL",
      SequenceNumber: 1,
      SortOrder: 1,
      standardizedMapping: "",
      isBold: true,
      EngagementId: this.engagementId,
      operation: "",
      IsNew: true,
      IsSubTotal: true,
      IsCustom: true,
      maxId: this.maxSmId + 1,
      //maxBSId: this.maxBSSmId + 1,
      isDeleted: false,
      isAddback: false,
      mappingOrder: false,
      isSelected: false,
      templateId: this.templateId,
      tagging: "",
      tagging_English: "",
      header_English: "",
      isDeletable: true,
      isEditable: true,
      subTotalId: maxsubId,
      user_Operation: "",
      userId: 0,
      layoutName: "",
      subtotalIds: [],
      isDuplicateMappingIdsInSubtotal: false,
      isMandatoryFieldEmpty: false
    };
    this.activePlugandPlaySubtotalIds = [...this.activePlugandPlaySubtotalIds, ...maxsubId];
    this.plugandplayDataNewPL = [...this.plugandplayDataNewPL, plugAndPlay];
    this.plugAndPlayData = [...this.plugandplayDataNewPL, ...this.plugandplayDataAddBacksPL, ...this.plugandplayDataNewBS].filter(x => x.smId == "");
    this.disableCustomSubtotal = this.plugAndPlayData.length == 52 ? true : false;

  }

  addCustomStdTotalMappingBS() {
    this.isUpdated = true;
    var maxsubId = "";

    var subtotalIdsData = this.remainingSubtotalIds.length > 0 ? this.remainingSubtotalIds : this.deletedSubtotalIds;
    subtotalIdsData.sort((a, b) => {
      if (a.length === b.length) {
        return a.localeCompare(b);
      }

      return a.length - b.length;
    });

    maxsubId = subtotalIdsData[0];

    if (this.remainingSubtotalIds.length > 0) {
      this.remainingSubtotalIds.splice(subtotalIdsData.indexOf[maxsubId], 1);
    }
    else {
      this.deletedSubtotalIds.splice(subtotalIdsData.indexOf[maxsubId], 1);
    }

    var plugAndPlay: CustomLayoutModel = {
      Id: 1,
      smId: "",
      Mapping: "BS",
      SequenceNumber: 1,
      SortOrder: 1,
      standardizedMapping: "",
      isBold: true,
      EngagementId: this.engagementId,
      operation: "",
      IsNew: true,
      IsSubTotal: true,
      IsCustom: true,
      maxId: this.maxSmId + 1,
      // maxBSId: this.maxBSSmId + 1,
      isDeleted: false,
      isAddback: false,
      mappingOrder: false,
      isSelected: false,
      templateId: this.templateId,
      tagging: "",
      tagging_English: "",
      header_English: "",
      isDeletable: true,
      isEditable: true,
      subTotalId: maxsubId,
      user_Operation: "",
      userId: 0,
      layoutName: "",
      subtotalIds: [],
      isDuplicateMappingIdsInSubtotal: false,
      isMandatoryFieldEmpty: false
    };
    this.activePlugandPlaySubtotalIds = [...this.activePlugandPlaySubtotalIds, ...maxsubId];
    this.plugandplayDataNewBS = [...this.plugandplayDataNewBS, plugAndPlay];
    this.plugAndPlayData = [...this.plugandplayDataNewPL, ...this.plugandplayDataAddBacksPL, ...this.plugandplayDataNewBS].filter(x => x.smId == "");
    this.disableCustomSubtotal = this.plugAndPlayData.length == 52 ? true : false;
  }

  tabChange(e) {
    this.isDivReadonly = false;
    this.index = e;
  }

  SaveUpdateMappingDetails(event) {
    return;
  }

  saveAllMappingDetails(isSaveclicked: any, isLayoutShared?: boolean) {
    var requestObject: CustomLayoutModel[];
    this.isSaveAsclicked = false;

    var newPLData = this.plugandplayDataNewPL.map((p) =>
      p.isAddback === true ? { ...p, isAddback: false } : p
    );

    this.addBackRow = this.addBackRow.length > 1 ? this.addBackRow.splice(1, this.addBackRow.length - 1) : this.addBackRow;

    var plugandPlayAddBacksWithAddbackRow = [
      ...this.addBackRow,
      ...this.plugandplayDataAddBacksPL,
    ];

    var plRequestObj = [];
    if (
      plugandPlayAddBacksWithAddbackRow.length > 0 &&
      plugandPlayAddBacksWithAddbackRow[0] !== undefined
    ) {
      plRequestObj = [
        ...newPLData,
        ...this.plugandplayDataDeletedPL,
        ...plugandPlayAddBacksWithAddbackRow,
      ];
    } else {
      plRequestObj = [...newPLData, ...this.plugandplayDataDeletedPL];
    }

    var bsRequestObj = [
      ...this.plugandplayDataNewBS,
      ...this.plugandplayDataDeletedBS,
    ];

    requestObject = [...plRequestObj, ...bsRequestObj];

    var emptyAddBackSection = this.plugandplayDataAddBacksPL.filter(
      (item, index) =>
        this.plugandplayDataAddBacksPL.findIndex(
          (x) => x.standardizedMapping.trim() === ""
        ) === index
    );

    if (emptyAddBackSection.length > 0) {
      emptyAddBackSection.forEach(x => {
        x.isMandatoryFieldEmpty = true;
      })
    }

    var duplicateAddBackSection = this.plugandplayDataAddBacksPL.filter(
      (item, index) =>
        this.plugandplayDataAddBacksPL.findIndex((x) => x.smId === item.smId) !=
        index
    );

    var stdMappingsDataForPL = newPLData.filter((x) => x.smId != "");
    var subTotalDataForPL = newPLData.filter((x) => x.smId === "");

    var stdMappingsDataForBS = this.plugandplayDataNewBS.filter(
      (x) => x.smId != ""
    );
    var subTotalDataForBS = this.plugandplayDataNewBS.filter(
      (x) => x.smId === ""
    );

    var duplicateCustomStdDataForPL = stdMappingsDataForPL.filter(
      (item, index) =>
        stdMappingsDataForPL.findIndex(
          (x) =>
            x.standardizedMapping.toLocaleLowerCase().trim() === item.standardizedMapping.toLocaleLowerCase().trim()
        ) != index
    );

    var duplicateCustomSubtotalDataForPL = subTotalDataForPL.filter(
      (item, index) =>
        subTotalDataForPL.findIndex(
          (x) =>
            x.standardizedMapping.toLocaleLowerCase().trim() === item.standardizedMapping.toLocaleLowerCase().trim()
        ) != index
    );

    var duplicateCustomStdDataForBS = stdMappingsDataForBS.filter(
      (item, index) =>
        stdMappingsDataForBS.findIndex(
          (x) =>
            x.standardizedMapping.toLocaleLowerCase().trim() === item.standardizedMapping.toLocaleLowerCase().trim()
        ) != index
    );

    var duplicateCustomSubtotalDataForBS = subTotalDataForBS.filter(
      (item, index) =>
        subTotalDataForBS.findIndex(
          (x) =>
            x.standardizedMapping.toLocaleLowerCase().trim() === item.standardizedMapping.toLocaleLowerCase().trim()
        ) != index
    );

    var pLData: any[] = [];
    var bSData: any[] = [];
    var addBacksData: any[] = [];
    pLData = newPLData;
    bSData = this.plugandplayDataNewBS;
    addBacksData = this.plugandplayDataAddBacksPL;

    // this.isValidFormula(pLData);
    // this.isValidFormula(bSData);
    this.isValidFormulaForAddbacks(addBacksData, pLData);
    this.isValidSubtotal(pLData);
    this.isValidSubtotal(bSData);

    var isInvalidstdMappingForPL = pLData.filter(
      (item) => item.isInValidStdMapping == true
    );
    var isInValidOperationForPL = pLData.filter(
      (item) => item.isValidOperation == true
    );
    var isInValidFormulaForPL = pLData.filter(
      (item) => item.isInValidMappingId == true
    );
    var isInValidStdMappingLengthForPL = pLData.filter(
      (item) => item.isInValidStdMappingLength == true
    );

    var isHasDuplicateMappingIDForPL = pLData.filter(
      (item) => (item.hasDuplicateNumbers == true || item.hasDuplicateSubtotalIds == true)
    );
    var isHasDuplicateMappingIDForAddBacks = addBacksData.filter(
      (item) => (item.hasDuplicateNumbers == true || item.hasDuplicateSubtotalIds == true)
    );
    var isHasDuplicateMappingIDForBS = bSData.filter(
      (item) => (item.hasDuplicateNumbers == true || item.hasDuplicateSubtotalIds == true)
    );

    var isInvalidstdMappingForBS = bSData.filter(
      (item) => item.isInValidStdMapping == true
    );
    var isInValidOperationForBS = bSData.filter(
      (item) => item.isValidOperation == true
    );
    var isInValidFormulaForBS = bSData.filter(
      (item) => item.isInValidMappingId == true
    );
    var isInValidStdMappingLengthForBS = bSData.filter(
      (item) => item.isInValidStdMappingLength == true
    );

    var isInValidStdMappingLengthForEBITDA = addBacksData.filter(
      (item) => item.isInValidStdMappingLength == true
    );

    var isInValidStdMappingEBITDA = addBacksData.filter(
      (item) => item.isInValidStdMapping == true
    );


    var isInValidSubtotalEBITDA = addBacksData.filter(
      (item) => item.isInValidSubtotalId == true
    );

    var isInValidOperationForEBITDA = addBacksData.filter(
      (item) => item.isValidOperation == true
    );
    var isInValidFormulaForEBITDA = addBacksData.filter(
      (item) => item.isInValidMappingId == true
    );


    var emptyStdMappingInPL = newPLData.filter(
      (x) => x.standardizedMapping.trim() === ""
    );

    if (emptyStdMappingInPL.length > 0) {
      emptyStdMappingInPL.forEach(x => {
        x.isMandatoryFieldEmpty = true;
      })
    }
    var emptySubTotal = newPLData.filter(
      (x) =>
        x.smId === "" &&
        (x.standardizedMapping.trim() === "" || x.operation.trim() === "")
    );
    if (emptySubTotal.length > 0) {
      emptySubTotal.forEach(x => {
        x.isMandatoryFieldEmpty = true;
      })
    }

    var emptyStdMappingInBS = this.plugandplayDataNewBS.filter(
      (x) => x.standardizedMapping.trim() === ""
    );

    if (emptyStdMappingInBS.length > 0) {
      emptyStdMappingInBS.forEach(x => {
        x.isMandatoryFieldEmpty = true;
      })
    }

    var emptySubTotalForBS = this.plugandplayDataNewBS.filter(
      (x) =>
        x.smId === "" &&
        (x.standardizedMapping.trim() === "" || x.operation.trim() === "")
    );

    if (emptySubTotalForBS.length > 0) {
      emptySubTotalForBS.forEach(x => {
        x.isMandatoryFieldEmpty = true;
      })
    }

    var emptyBalanceSheetGroup = this.plugandplayDataNewBS.filter(
      (x) => x.smId != "" && x.tagging.trim() === ""
    );
    var isInValidSubtotalaIdForPL = pLData.filter(
      (item) => item.isInValidSubtotalId == true
    );

    var isInValidSubtotalaIdForBS = bSData.filter(
      (item) => item.isInValidSubtotalId == true
    );

    // var isDuplicateMappingIdsInSubtotalPL = pLData.filter(
    //   (item) => item.isDuplicateMappingIdsInSubtotal == true
    // );

    // var isDuplicateMappingIdsInSubtotalBS = bSData.filter(
    //   (item) => item.isDuplicateMappingIdsInSubtotal == true
    // );

    // var isDuplicateMappingIdsInSubtotalEBITDA = addBacksData.filter(
    //   (item) => item.isDuplicateMappingIdsInSubtotal == true
    // );

    if (isInValidFormulaForPL.length > 0 || isInValidFormulaForBS.length > 0 || isInValidFormulaForEBITDA.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError1,
        life: 10000,
      });
    }

    if (isHasDuplicateMappingIDForPL.length > 0 || isHasDuplicateMappingIDForAddBacks.length > 0 || isHasDuplicateMappingIDForBS.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.DuplicateIDErrorMesage,
        life: 10000,
      });
    }

    if (isInValidSubtotalaIdForPL.length > 0 || isInValidSubtotalaIdForBS.length > 0 || isInValidSubtotalEBITDA.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError11,
        life: 10000,
      });
    }

    if (emptyAddBackSection.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError9,
        life: 10000,
      });
    }

    if (duplicateAddBackSection.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError3,
        life: 10000,
      });
    }

    if (
      isInvalidstdMappingForPL.length > 0 ||
      isInvalidstdMappingForBS.length > 0 ||
      isInValidStdMappingLengthForBS.length > 0 ||
      isInValidStdMappingLengthForPL.length > 0 ||
      isInValidStdMappingEBITDA.length > 0 ||
      isInValidStdMappingLengthForEBITDA.length > 0
    ) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError3,
        life: 10000,
      });
    }

    if (
      isInValidOperationForPL.length > 0 ||
      isInValidOperationForBS.length > 0 || isInValidOperationForEBITDA.length > 0
    ) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError2,
        life: 10000,
      });
    }

    if (
      duplicateCustomStdDataForPL.length > 0 ||
      duplicateCustomStdDataForBS.length > 0
    ) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError3,
        life: 10000,
      });
    }

    if (
      duplicateCustomSubtotalDataForPL.length > 0 ||
      duplicateCustomSubtotalDataForBS.length > 0
    ) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError3,
        life: 10000,
      });
    }

    if (
      emptyStdMappingInPL.length > 0 ||
      emptyStdMappingInBS.length > 0
    ) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError4,
        life: 10000,
      });
    }
    if (emptySubTotal.length > 0 || emptySubTotalForBS.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError4,
        life: 10000,
      });
    }

    if (emptyBalanceSheetGroup.length > 0) {
      this.nextClick = false;
      return this.messageService.add({
        key: this.currLangTranslation.severitymessage.key2,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.plugAndPlay.ValidationError10,
        life: 10000,
      });
    }

    var smIds = [];
    if (
      this.plugandplayDataDeletedPL.length > 0 ||
      this.plugandplayDataDeletedBS.length > 0
    ) {
      this.plugandplayDataDeletedPL?.forEach((item) => {
        if (item.isDeleted) {
          smIds.push(Number(item.smId));
        }
      });

      this.plugandplayDataDeletedBS?.forEach((item) => {
        if (item.isDeleted) {
          smIds.push(Number(item.smId));
        }
      });
    }
    this.loadspinner = true;

    this.MissingSMIDCheck(requestObject, smIds, isSaveclicked, isLayoutShared)
  }


  saveAlldata(requestObject: any, smIds: any, isSaveclicked: boolean, isLayoutShared: boolean) {

    if (this.environment === 'uat' || this.environment === 'prod') {

      var apiUS: any;
      var apiEMEIA: any;
      var apiAPAC: any;
      if (isLayoutShared) {
        apiUS = this.customizedLayoutService.ShareLayoutUS(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate, this.Users,true);
        apiEMEIA = this.customizedLayoutService.ShareLayoutEMEIA(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate, this.Users,false);
        apiAPAC = this.customizedLayoutService.ShareLayoutAPAC(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate, this.Users,false);

      }
      else {
        apiUS = this.customizedLayoutService.saveAllDataUS(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate);
        apiEMEIA = this.customizedLayoutService.saveAllDataEMEIA(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate);
        apiAPAC = this.customizedLayoutService.saveAllDataAPAC(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate);

      }

      forkJoin([apiUS, apiEMEIA, apiAPAC]).subscribe((response: any) => {
        if (!response[0].isSuccess) {
          this.loadspinner = false;
          var data = response[0].masterScheduleMapping;

          var tempDataPL = data.filter(x => x.schedule == "PL" && x.isDuplicateMappingIdsInSubtotal === true);
          var tempDataBS = data.filter(x => x.schedule == "BS" && x.isDuplicateMappingIdsInSubtotal === true);

          if (tempDataPL.length > 0) {
            this.plugandplayDataNewPL.forEach(x => {
              if (x.smId == "" && tempDataPL.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                x.isDuplicateMappingIdsInSubtotal = true;
              }
              else {
                x.isDuplicateMappingIdsInSubtotal = false;
              }
            });

            this.plugandplayDataAddBacksPL.forEach(x => {
              if (x.smId == "" && tempDataPL.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                x.isDuplicateMappingIdsInSubtotal = true;
              }
              else {
                x.isDuplicateMappingIdsInSubtotal = false;
              }
            });
          }

          if (tempDataBS.length > 0) {
            this.plugandplayDataNewBS.forEach(x => {
              if (x.smId == "" && tempDataBS.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                x.isDuplicateMappingIdsInSubtotal = true;
              }
              else {
                x.isDuplicateMappingIdsInSubtotal = false;
              }
            });
          }
          this.isSaveAsclicked = false;
          this.isShareClicked = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key2,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.plugAndPlay.ValidationError12,
            life: 10000,
          });

          return;
        }
        else {
          this.loadspinner = false;
          this.isSaveAsclicked = false;
          this.isShareClicked = false;
          this.isSaved = true;
          this.isCreateLayoutClicked = false;
          if (isSaveclicked) {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key2,
              severity: severitymessage.success,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.customizedLayouts.ModificationSuccessMessage,
              life: 10000,
            });
          }

          this.customizedLayoutService
            .getCustomizedLayoutByUserId(this.loggedInUserId, this.templateId, this.layoutName, Number(this.selectedLanguageId))
            .subscribe((data: any) => {
              this.plugandplayDataPL = data.message.filter(
                (x) =>
                  x.mapping == "PL" &&
                  x.isDeleted == false &&
                  x.isAddback == false
              );
              this.enableSaveAndDelete = true;
              this.getCustomTemplates(this.loggedInUserId);
              //this.selectedCustomTemplate = this.layoutName;
              this.BaseLayout = (this.customTemplateList.find(x=>x.layoutName == this.selectedCustomTemplate)?.templateId == 1) ? 'Americas' : 'ROW';
              this.plugAndPlayData = data.message.filter(x => x.isDeleted == false && x.isAddback === false);

              this.plugandplayAddbackPL = data.message.filter(
                (x) =>
                  x.isAddback == true
              );
              this.maxSmId = this.plugAndPlayData[0]["maxId"];


              this.maxSubtotalID = this.plugAndPlayData[0]["maxSubTotalId"];

              this.disableCustomSubtotal = this.maxSubtotalID == 52 ? true : false;

              var activePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == false);
              activePlugAndPlayDataForSubtotals.forEach(item => {
                this.activePlugandPlaySubtotalIds.push(
                  item.subTotalId
                )
              });

              var inActivePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == true);
              inActivePlugAndPlayDataForSubtotals.forEach(item => {
                this.inactivePlugandPlaySubtotalIds.push(
                  item.subTotalId
                )
              });

              this.plugandplayDataBS = data.message.filter(
                (x) => x.mapping == "BS" && x.isDeleted == false
              );

              this.plugandplayDataPL.forEach(x => {
                x.isDeletable = x.header_English === "Revenue" || x.header_English === "Net revenue" || x.header_English === "Net income / (loss)" || x.header_English === "Operating expense" ? false : true;
              });

              this.plugandplayDataBS.forEach(x => {
                x.isDeletable = x.isEditable = x.header_English === "Equity" ? false : true;
              });

              this.addBacksLabel = this.plugandplayAddbackPL.length > 0 ? this.plugandplayAddbackPL.find(x => x.smId === "-2").standardizedMapping : "";

              this.plugandplayAddbackPL.forEach(x => {
                x.isEditable = x.smId === "" ? false : true;
              });

              let indexToRemove = this.plugandplayAddbackPL.findIndex(
                (item) => item.smId === "-2" //for add backs
              );

              let row$ = this.plugandplayAddbackPL[indexToRemove];
              this.addBackRow.push(row$);

              if (indexToRemove != -1)
                this.plugandplayAddbackPL.splice(indexToRemove, 1);

              this.plugandplayDataNewPL = [...this.plugandplayDataPL];
              this.plugandplayDataAddBacksPL = [...this.plugandplayAddbackPL];
              this.plugandplayDataNewBS = [...this.plugandplayDataBS];
              this.loadspinner = false;
            });
        }
      },
        (error) => {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key2,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: "Error occured.",
            life: 10000,
          });
        }
      );


    } else {

      if (isLayoutShared) {
        this.customizedLayoutService.ShareData(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate, this.Users, true).subscribe(
          (response: any) => {
            if (!response.isSuccess) {
              this.loadspinner = false;
              var data = response.masterScheduleMapping;

              var tempDataPL = data.filter(x => x.schedule == "PL" && x.isDuplicateMappingIdsInSubtotal === true);
              var tempDataBS = data.filter(x => x.schedule == "BS" && x.isDuplicateMappingIdsInSubtotal === true);

              if (tempDataPL.length > 0) {
                this.plugandplayDataNewPL.forEach(x => {
                  if (x.smId == "" && tempDataPL.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                    x.isDuplicateMappingIdsInSubtotal = true;
                  }
                  else {
                    x.isDuplicateMappingIdsInSubtotal = false;
                  }
                });

                this.plugandplayDataAddBacksPL.forEach(x => {
                  if (x.smId == "" && tempDataPL.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                    x.isDuplicateMappingIdsInSubtotal = true;
                  }
                  else {
                    x.isDuplicateMappingIdsInSubtotal = false;
                  }
                });
              }

              if (tempDataBS.length > 0) {
                this.plugandplayDataNewBS.forEach(x => {
                  if (x.smId == "" && tempDataBS.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                    x.isDuplicateMappingIdsInSubtotal = true;
                  }
                  else {
                    x.isDuplicateMappingIdsInSubtotal = false;
                  }
                });
              }
              this.isSaveAsclicked = false;
              this.isShareClicked = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key2,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.plugAndPlay.ValidationError12,
                life: 10000,
              });

              return;
            }
            else {
              this.loadspinner = false;
              this.isSaveAsclicked = false;
              this.isShareClicked = false;
              this.isSaved = true;
              this.isCreateLayoutClicked = false;
              if (isSaveclicked) {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key2,
                  severity: severitymessage.success,
                  summary: this.currLangTranslation.severitymessage.notification,
                  detail: this.currLangTranslation.customizedLayouts.ModificationSuccessMessage,
                  life: 10000,
                });
              }

              this.customizedLayoutService
                .getCustomizedLayoutByUserId(this.loggedInUserId, this.templateId, this.layoutName, Number(this.selectedLanguageId))
                .subscribe((data: any) => {
                  data = data.filter((item, index, self) =>
                    index === self.findIndex((t) => t.smId === item.smId)
                  );
                  this.plugandplayDataPL = data.message.filter(
                    (x) =>
                      x.mapping == "PL" &&
                      x.isDeleted == false &&
                      x.isAddback == false
                  );
                  this.enableSaveAndDelete = true;
                  this.getCustomTemplates(this.loggedInUserId);
                  //this.selectedCustomTemplate = this.layoutName;
                  this.plugAndPlayData = data.message.filter(x => x.isDeleted == false && x.isAddback === false);

                  this.plugandplayAddbackPL = data.message.filter(
                    (x) =>
                      x.isAddback == true
                  );
                  this.maxSmId = this.plugAndPlayData[0]["maxId"];


                  this.maxSubtotalID = this.plugAndPlayData[0]["maxSubTotalId"];

                  this.disableCustomSubtotal = this.maxSubtotalID == 52 ? true : false;

                  var activePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == false);
                  activePlugAndPlayDataForSubtotals.forEach(item => {
                    this.activePlugandPlaySubtotalIds.push(
                      item.subTotalId
                    )
                  });

                  var inActivePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == true);
                  inActivePlugAndPlayDataForSubtotals.forEach(item => {
                    this.inactivePlugandPlaySubtotalIds.push(
                      item.subTotalId
                    )
                  });

                  this.plugandplayDataBS = data.message.filter(
                    (x) => x.mapping == "BS" && x.isDeleted == false
                  );

                  this.plugandplayDataPL.forEach(x => {
                    x.isDeletable = x.header_English === "Revenue" || x.header_English === "Net revenue" || x.header_English === "Net income / (loss)" || x.header_English === "Operating expense" ? false : true;
                  });

                  this.plugandplayDataBS.forEach(x => {
                    x.isDeletable = x.isEditable = x.header_English === "Equity" ? false : true;
                  });

                  this.addBacksLabel = this.plugandplayAddbackPL.length > 0 ? this.plugandplayAddbackPL.find(x => x.smId === "-2").standardizedMapping : "";

                  this.plugandplayAddbackPL.forEach(x => {
                    x.isEditable = x.smId === "" ? false : true;
                  });

                  let indexToRemove = this.plugandplayAddbackPL.findIndex(
                    (item) => item.smId === "-2" //for add backs
                  );

                  let row$ = this.plugandplayAddbackPL[indexToRemove];
                  this.addBackRow.push(row$);

                  if (indexToRemove != -1)
                    this.plugandplayAddbackPL.splice(indexToRemove, 1);

                  this.plugandplayDataNewPL = [...this.plugandplayDataPL];
                  this.plugandplayDataAddBacksPL = [...this.plugandplayAddbackPL];
                  this.plugandplayDataNewBS = [...this.plugandplayDataBS];
                  this.loadspinner = false;
                });
            }
          },
          (error) => {
            if(error.error.message == 'cannot be Shared more than 10 layouts'){
              this.loadspinner = false;
              this.isShareClicked = false;
            }
            else{
            this.loadspinner = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key2,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: "Error occured.",
              life: 10000,
            });
            }
          
          }
        );
      }
      else {
        this.customizedLayoutService.saveAllData(requestObject, smIds, this.regionId, this.layoutName, this.templateId, isSaveclicked, Number(this.selectedLanguageId), this.selectedCustomTemplate).subscribe(
          (response: any) => {
            if (!response.isSuccess) {
              this.loadspinner = false;
              var data = response.masterScheduleMapping;

              var tempDataPL = data.filter(x => x.schedule == "PL" && x.isDuplicateMappingIdsInSubtotal === true);
              var tempDataBS = data.filter(x => x.schedule == "BS" && x.isDuplicateMappingIdsInSubtotal === true);

              if (tempDataPL.length > 0) {
                this.plugandplayDataNewPL.forEach(x => {
                  if (x.smId == "" && tempDataPL.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                    x.isDuplicateMappingIdsInSubtotal = true;
                  }
                  else {
                    x.isDuplicateMappingIdsInSubtotal = false;
                  }
                });

                this.plugandplayDataAddBacksPL.forEach(x => {
                  if (x.smId == "" && tempDataPL.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                    x.isDuplicateMappingIdsInSubtotal = true;
                  }
                  else {
                    x.isDuplicateMappingIdsInSubtotal = false;
                  }
                });
              }

              if (tempDataBS.length > 0) {
                this.plugandplayDataNewBS.forEach(x => {
                  if (x.smId == "" && tempDataBS.find(y => y.header_English == (x.header_English != "" ? x.header_English : x.standardizedMapping))) {
                    x.isDuplicateMappingIdsInSubtotal = true;
                  }
                  else {
                    x.isDuplicateMappingIdsInSubtotal = false;
                  }
                });
              }
              this.isSaveAsclicked = false;
              this.isShareClicked = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key2,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.plugAndPlay.ValidationError12,
                life: 10000,
              });

              return;
            }
            else {
              this.loadspinner = false;
              this.isSaveAsclicked = false;
              this.isShareClicked = false;
              // if(this.isSharedLayout){
              //   this.isShareButtonDisabled = true;
              // }

              this.isShareButtonDisabled = this.isSharedLayout ? true : false;
              this.isSaved = true;
              this.isCreateLayoutClicked = false;
              if (isSaveclicked) {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key2,
                  severity: severitymessage.success,
                  summary: this.currLangTranslation.severitymessage.notification,
                  detail: this.currLangTranslation.customizedLayouts.ModificationSuccessMessage,
                  life: 10000,
                });
              }
              this.customizedLayoutService
                .getCustomizedLayoutByUserId(this.loggedInUserId, this.templateId, this.layoutName, Number(this.selectedLanguageId))
                .subscribe((data: any) => {
                  this.plugandplayDataPL = data.message.filter(
                    (x) =>
                      x.mapping == "PL" &&
                      x.isDeleted == false &&
                      x.isAddback == false
                  );
                  this.enableSaveAndDelete = true;
                  this.getCustomTemplates(this.loggedInUserId);
                  this.selectedCustomTemplate = this.layoutName;
                  this.plugAndPlayData = data.message.filter(x => x.isDeleted == false && x.isAddback === false);

                  this.plugandplayAddbackPL = data.message.filter(
                    (x) =>
                      x.isAddback == true
                  );
                  this.maxSmId = this.plugAndPlayData[0]["maxId"];


                  this.maxSubtotalID = this.plugAndPlayData[0]["maxSubTotalId"];

                  this.disableCustomSubtotal = this.maxSubtotalID == 52 ? true : false;

                  var activePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == false);
                  activePlugAndPlayDataForSubtotals.forEach(item => {
                    this.activePlugandPlaySubtotalIds.push(
                      item.subTotalId
                    )
                  });

                  var inActivePlugAndPlayDataForSubtotals = data.message.filter(x => x.smId == "" && x.isDeleted == true);
                  inActivePlugAndPlayDataForSubtotals.forEach(item => {
                    this.inactivePlugandPlaySubtotalIds.push(
                      item.subTotalId
                    )
                  });

                  this.plugandplayDataBS = data.message.filter(
                    (x) => x.mapping == "BS" && x.isDeleted == false
                  );

                  this.plugandplayDataPL.forEach(x => {
                    x.isDeletable = x.header_English === "Revenue" || x.header_English === "Net revenue" || x.header_English === "Net income / (loss)" || x.header_English === "Operating expense" ? false : true;
                  });

                  this.plugandplayDataBS.forEach(x => {
                    x.isDeletable = x.isEditable = x.header_English === "Equity" ? false : true;
                  });

                  this.addBacksLabel = this.plugandplayAddbackPL.length > 0 ? this.plugandplayAddbackPL.find(x => x.smId === "-2").standardizedMapping : "";

                  this.plugandplayAddbackPL.forEach(x => {
                    x.isEditable = x.smId === "" ? false : true;
                  });

                  let indexToRemove = this.plugandplayAddbackPL.findIndex(
                    (item) => item.smId === "-2" //for add backs
                  );

                  let row$ = this.plugandplayAddbackPL[indexToRemove];
                  this.addBackRow.push(row$);

                  if (indexToRemove != -1)
                    this.plugandplayAddbackPL.splice(indexToRemove, 1);

                  this.plugandplayDataNewPL = [...this.plugandplayDataPL];
                  this.plugandplayDataAddBacksPL = [...this.plugandplayAddbackPL];
                  this.plugandplayDataNewBS = [...this.plugandplayDataBS];
                  this.loadspinner = false;
                });
            }
          },
          (error) => {
            this.loadspinner = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key2,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: "Error occured.",
              life: 10000,
            });
          }
        );

      }

    }
  }

  private getTemplates(regionId: number): void {
    this.regionService
      .getTemplates(regionId)
      .subscribe((data: RegionModel[]) => {
        this.templateList = data.filter(x => x.Id != 3);
        console.log(this.templateList, 'templist');
      });
  }

  private getCustomTemplates(userId: number): void {

    this.customizedLayoutService
      .GetLayoutNames(userId)
      .subscribe((data) => {
        this.customTemplateList = data;

        var sharedTemplateList = data.filter(x => x.layoutName.includes('shared'));
        this.customTemplatesWithoutSharedLayout = this.customTemplateList.filter(item=> !sharedTemplateList.includes(item));      
        sharedTemplateList.sort((a, b) => a.layoutName.localeCompare(b.layoutName));

        this.customTemplateList = [...this.customTemplatesWithoutSharedLayout , ...sharedTemplateList];
        console.log(this.selectedCustomTemplate,'selTemplate');
         this.BaseLayout = (this.customTemplateList.find(x=>x.layoutName == this.selectedCustomTemplate)?.templateId == 1) ? 'Americas' : 'ROW';
        this.isShareButtonDisabled = this.customTemplateList.filter(x => x.layoutName.includes('shared')).length > 10 || this.isSharedLayout ? true : false;

        console.log(this.customTemplateList, 'custList');
      });
  }


  disableReadOnly(disabled: boolean): void {
    this.divModifySecound = true;
    this.divModifyFirst = false;
    this.isDivReadonly = disabled;
  }

  onRowReorder(event) {
    this.isUpdated = true;
    var dropIndex = this.plugandplayDataNewPL[event.dropIndex];
    var dragIndex = this.plugandplayDataNewPL[event.dragIndex];
    var lastindex = this.plugandplayDataNewPL.length - 1;

    var plugandplayDataNewPL = this.plugandplayDataNewPL;

    var smID = dropIndex["id"];
    var subTotalId;

    for (var i = event.dropIndex; i <= lastindex; i++) {
      var details = this.plugandplayDataNewPL[i];
      if (details["isBold"] === true) {
        subTotalId = details["id"];
        i = lastindex + 2;
      }
    }

    var plugAndPlayDragData: PlugAndPlayDragModel = {
      Id: smID,
      SubTotalId: subTotalId,
      EngagementId: this.engagementId,
    };
  }

  GoBackToVerificationScreen() {
    this.router.navigate(["/engagement/", this.engagementId, "scenario"]);
  }

  GoBackToMappingScreen() {
    this.router.navigate([
      "/engagement/",
      this.engagementId,
      "uploaddownloadflatfile",
    ]);
  }



  toggleMaximize() {
    this.isMaximized = !this.isMaximized;
  }

  onDropdownChange(selectedValue, rowData, pldata) {
    this.isUpdated = true;
    if (selectedValue !== "Select") {
      var pldata1 = this.plugandplayDataNewPL.find(
        (a) => a.standardizedMapping.trim() == selectedValue.trim()
      );

      this.plugandplayDataAddBacksPL.splice(rowData, 1, pldata1);

      this.plugandplayDataAddBacksPL[rowData].isAddback = true;
    } else {
      var plugAndPlay: CustomLayoutModel = {
        Id: 1,
        smId: "00",
        Mapping: "PL",
        SequenceNumber: 1,
        SortOrder: 1,
        standardizedMapping: "",
        isBold: false,
        EngagementId: this.engagementId,
        operation: "",
        IsNew: true,
        IsSubTotal: false,
        IsCustom: true,
        maxId: this.maxSmId + 1,
        //maxBSId: this.maxBSSmId + 1,
        isDeleted: false,
        isAddback: true,
        mappingOrder: false,
        isSelected: false,
        templateId: this.templateId,
        tagging: "",
        tagging_English: "",
        header_English: "",
        isDeletable: true,
        isEditable: true,
        subTotalId: "",
        user_Operation: "",
        userId: 0,
        layoutName: "",
        subtotalIds: [],
        isDuplicateMappingIdsInSubtotal: false,
        isMandatoryFieldEmpty: false
      };

      this.plugandplayDataAddBacksPL.splice(rowData, 1, plugAndPlay);
    }
  }
  SetMappingOrder(rowData) {
    this.isUpdated = true;
    if (rowData.mappingOrder == false) rowData.mappingOrder = true;
    else if (rowData.mappingOrder == true) rowData.mappingOrder = false;
  }

  onInputChange(field, value, rowData) {
    if (rowData.isDuplicateMappingIdsInSubtotal) {
      rowData.isDuplicateMappingIdsInSubtotal = false;
    }

    if (rowData.hasDuplicateNumbers) {
      rowData.hasDuplicateNumbers = false;
    }

    if (rowData.hasDuplicateSubtotalIds) {
      rowData.hasDuplicateSubtotalIds = false;
    }

    rowData.isMandatoryFieldEmpty = rowData.isMandatoryFieldEmpty ? false : rowData.isMandatoryFieldEmpty;

    this.isUpdated = true;
    var smIdsForPL: any[] = [];
    var subtotalIds: any[] = [];
    var data = this.index === 0 ? this.plugandplayDataNewPL : this.plugandplayDataNewBS;

    data.forEach((x) => {
      smIdsForPL.push(x.smId);
      subtotalIds.push(x.subTotalId);
    });
    var numbers = value.match(/[0-9]+/g);
    var subtotalIdsfromOperation = value.match(/[A-Za-z]+/g);
    var isValidMappingId = true;
    var isValidSubtotals = true;
    numbers?.forEach((x) => {
      isValidMappingId = smIdsForPL.includes(x) ? true : false;
    });

    subtotalIdsfromOperation?.forEach((x) => {
      isValidSubtotals = subtotalIds.includes(x.toUpperCase()) ? true : false;
    });

    var pattern;
    if (field === "operation") {
      pattern = /^=([\d+\-=\s [A-Za-z]+)$/;
      rowData.isInValidMappingId = isValidMappingId ? false : true;
      rowData.isInValidSubtotalId = isValidSubtotals ? false : true;
      if (pattern.test(value)) {
        rowData.isValidOperation = false;
      } else {
        rowData.isValidOperation = true;
      }
    } else if (field === "standardizedMapping") {
      pattern = /[@"\`!#$%^<>?+_~\\;:=\\{}]/;
      if (pattern.test(value)) {
        rowData.isInValidStdMapping = true;
      } else {
        rowData.isInValidStdMapping = false;
      }
      rowData.isInValidStdMappingLength = value.length > 100 ? true : false;
    }

    if (this.index === 0) {
      this.plugandplayDataAddBacksPL.forEach((item) => {
        if (item.smId != "" && item.smId == rowData.smId) {
          item.standardizedMapping = rowData.standardizedMapping;
        }
      });
    }
  }


  deleteCustomizedLayout(layoutName) {
    this.confirmationService.confirm({
      key: this.normalConfirmKeyDelete,
      message: this.currLangTranslation.customizedLayouts.WarningMessage1,
      header: this.currLangTranslation.labels.warning,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      acceptLabel: this.currLangTranslation.actionButtons.yes,

      accept: () => {
        if (this.environment === 'uat' || this.environment === 'prod') {
          const apiUS = this.customizedLayoutService.deleteCustomizedLayoutUS(this.userEmail, this.templateId, layoutName);
          const apiEMEIA = this.customizedLayoutService.deleteCustomizedLayoutEMEIA(this.userEmail, this.templateId, layoutName);
          const apiAPAC = this.customizedLayoutService.deleteCustomizedLayoutAPAC(this.userEmail, this.templateId, layoutName);

          forkJoin([apiUS, apiEMEIA, apiAPAC]).subscribe((response: any) => {
            if (response[0] == true) {
              this.getCustomTemplates(this.loggedInUserId);
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key2,
                severity: severitymessage.success,
                summary:
                  this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.customizedLayouts.DeleteMessage,
                life: 10000,
              });
              this.plugandplayDataNewPL = [];
              this.plugandplayDataNewBS = [];
              this.plugandplayDataAddBacksPL = [];
              this.getCustomTemplates(this.loggedInUserId);
              this.selectedCustomTemplate = "0";
              this.enableSaveAndDelete = false;
            }
          });

        } else {
          this.customizedLayoutService
            .deleteCustomizedLayout(this.userEmail, this.templateId, layoutName).subscribe(
              (response: any) => {
                if (response == true) {
                  this.getCustomTemplates(this.loggedInUserId);
                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key2,
                    severity: severitymessage.success,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail: this.currLangTranslation.customizedLayouts.DeleteMessage,
                    life: 10000,
                  });
                  this.plugandplayDataNewPL = [];
                  this.plugandplayDataNewBS = [];
                  this.plugandplayDataAddBacksPL = [];
                  this.getCustomTemplates(this.loggedInUserId);
                  this.selectedCustomTemplate = "0";
                  this.enableSaveAndDelete = false;
                }

              });
        }

      }
    });

  }

  onBalanceSheetGroupChange(value, rowIndex, rowData) {
    this.isUpdated = true;
    var bsData = this.plugandplayDataNewBS.find((a) => a.smId == rowData.smId);
    bsData.tagging = value;
    bsData.tagging_English = value;
  }

  sort() {
    this.isUpdated = true;
  }


  isValidSubtotal(data: any) {

    var allSubtotalIds: any[] = [];
    var smIds: any[] = [];

    data.forEach((x) => {
      if (x.smId == "") {
        allSubtotalIds.push(x.subTotalId);
      }
    });
    data.forEach((x) => {
      smIds.push(x.smId);
    });
    data.forEach((item) => {
      if (item.smId === "") {
        if (item.operation != "") {

          var numbers = item.operation.match(/[0-9]+/g);
          var subtotalIds = item.operation.match(/[A-Za-z]+/g);

          subtotalIds = subtotalIds?.map(x => x.toUpperCase());

          let isValidMappingId = !numbers?.some((string) => smIds.indexOf(string) == -1);
          let isValidSubtotalId = !subtotalIds?.some((string) => allSubtotalIds.indexOf(string) == -1);

          item.isInValidMappingId = isValidMappingId ? false : true;
          item.isInValidSubtotalId = isValidSubtotalId ? false : true;

          let isDuplicateNumbers = numbers ? new Set(numbers).size !== numbers.length : false;
          let isDuplicateSubtotalIds = subtotalIds ? new Set(subtotalIds).size !== subtotalIds.length : false;

          item.hasDuplicateNumbers = isDuplicateNumbers ? true : false;
          item.hasDuplicateSubtotalIds = isDuplicateSubtotalIds ? true : false;

        }
      }
    });
  }



  isValidFormulaForAddbacks(data: any, plData: any) {
    var smIds: any[] = [];
    var subtotalIds: any[] = [];


    plData.forEach((x) => {
      smIds.push(x.smId);
      if (x.smId == "") {
        subtotalIds.push(x.subTotalId);
      }
    });
    data.forEach((item) => {
      if (item.smId === "") {
        if (item.operation != "") {
          var numbers = item.operation.match(/[0-9]+/g);
          var subtotalId = item.operation.match(/[A-Za-z]+/g);

          subtotalId = subtotalId?.map(x => x.toUpperCase());

          let isValidMappingId = !numbers?.some((string) => smIds.indexOf(string) == -1);

          let isValidSubtotalIds = !subtotalId?.some((string) => subtotalIds.indexOf(string) == -1);

          item.isInValidMappingId = isValidMappingId ? false : true;
          item.isInValidSubtotalId = isValidSubtotalIds ? false : true;

          let isDuplicateNumbers = numbers ? new Set(numbers).size !== numbers.length : false;
          let isDuplicateSubtotalIds = subtotalId ? new Set(subtotalId).size !== subtotalId.length : false;

          item.hasDuplicateNumbers = isDuplicateNumbers ? true : false;
          item.hasDuplicateSubtotalIds = isDuplicateSubtotalIds ? true : false;

        }
      }
    });
  }



  CreateNewLayout() {
    this.plugandplayDataNewPL = [];
    this.plugandplayDataNewBS = [];
    this.plugandplayDataAddBacksPL = [];
    this.isCreateLayoutClicked = true;
    this.isDataLoaded = true;
    this.isSaved = false;
    this.enableSaveAndDelete = false;
    this.selectedTemplate = "0";
    this.selectedLanguageId = "0";
    this.selectedCustomTemplate = "0";
  }

  saveAs() {
    this.layoutName = null;
    this.isSaveAsclicked = true;
  }

  onLayoutNameChange(layoutName) {
    const pattern = /[@*"\`\\()/';:=\[\]]/;
    if (pattern.test(layoutName)) {
      this.isValidLayoutName = false;
    } else {
      this.isValidLayoutName = true;
    }
    this.isValidLayoutNameLength = layoutName.length > 50 ? false : true;

    this.isDuplicateLayoutName = this.customTemplateList.filter(x => x.layoutName.toLocaleLowerCase().trim() == layoutName.toLocaleLowerCase().trim()).length > 0 ? true : false;
  }

  save() {
    this.confirmationService.confirm({
      key: this.normalConfirmKeyDelete,
      message: this.currLangTranslation.customizedLayouts.WarningMessage2,
      header: this.currLangTranslation.labels.warning,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {
        this.layoutName = this.selectedCustomTemplate;
        this.saveAllMappingDetails(true);
      },
      reject: () => { },
    });
  }

  MissingSMIDCheck(requestObject: any, smIds: any, isSaveclicked: boolean, isLayoutShared) {
    var smidx: any[] = [];
    var osmidx: any[] = [];
    this.plugandplayDataNewPL.forEach((item) => {
      if (item.smId != "") {
        smidx.push(item.smId);
      }
    });

    this.plugandplayDataNewPL.forEach((oitem) => {
      if (oitem.operation != "" && oitem.smId === "") {
        var numbers1 = oitem.operation.match(/[0-9]+/g);
        if (numbers1 !== null) {
          numbers1.forEach((oitems) => {
            osmidx.push(oitems)
          });
        }
      }
    });

    this.plugandplayDataNewBS.forEach((item) => {
      if (item.smId != "") {
        smidx.push(item.smId);
      }
    });

    this.plugandplayDataNewBS.forEach((oitem) => {
      if (oitem.operation != "" && oitem.smId === "") {
        var numbers1 = oitem.operation.match(/[0-9]+/g);
        if (numbers1 !== null) {
          numbers1.forEach((oitems) => {
            osmidx.push(oitems)
          });
        }
      }
    });
    var msmid = smidx.filter((f) => !osmidx.includes(f));

    if (msmid.length !== 0) {
      let text = msmid.toString();
      let mtext = '';

      if (msmid.length == 1) {
        mtext = this.currLangTranslation.plugAndPlay.MissingMappingId;
      }
      else {
        mtext = this.currLangTranslation.plugAndPlay.MissingMappingIds;
      }

      mtext = mtext.replace(/SMIDCG/g, text);
      this.confirmationService.confirm({
        key: this.normalConfirmKeyDelete2,
        message: mtext,
        header: this.currLangTranslation.labels.warning,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.loadspinner = false;
          if (isSaveclicked) {
            this.saveAlldata(requestObject, smIds, true, isLayoutShared);
          }
          else {
            this.saveAlldata(requestObject, smIds, false, isLayoutShared);
          }

        },
        reject: () => {
          this.loadspinner = false
        },

      });
    }

    else {
      if (isSaveclicked) {
        this.saveAlldata(requestObject, smIds, true, isLayoutShared);
      }
      else {
        this.saveAlldata(requestObject, smIds, false, isLayoutShared);
      }
    }
  }

  GetAllActiveLanguages() {
    this.engagementService
      .GetAllActiveLanguages()
      .subscribe((data: MasterLanguage[]) => {
        this.languages = data;

      });
  }

  Share() {
    this.isShareClicked = true;
    this.isValidEmailId = true;
  }

  GetAllUsers() {
    this.userService.GetAllUsers().subscribe((data: any) => {
      this.UsersList = data;
      console.log("users", this.UsersList);
    });
  }

  // searchUsers(event) {
  //   let search = event.query.split(';').pop()?.trim();
  //   //var search = event.query;
  //   //this.isValidEmailId = (search.endsWith('@ey.com') || search.endsWith('@parthenon.ey.com')) ? true : false;
  //   this.results = this.UsersList.filter(item =>
  //     item.UPN.toLowerCase().includes(search.toLowerCase())
  //   );
  // }

   searchUsers(event) {
      this.userService.getADUsers(event.query).subscribe(
        (data: UserModel[]) => {
          this.results = data;
        },
        (error) => { }
      );
    }

  validateEmailId() {
    this.Users.forEach(enteredValue => {
      if (enteredValue.UPN == "" || enteredValue.UPN.endsWith('@ey.com') || enteredValue.UPN.endsWith('@parthenon.ey.com')) {
        if (enteredValue.UPN == "" || this.UsersList.filter(x => x.UPN === enteredValue.UPN).length > 0) {
          this.isValidEmailId = true;
        }
        else {
          this.isValidEmailId = false;
          return;
        }
      }
      else {
        this.isValidEmailId = false;
        return;
      }
    });
  }
  // captureManualValue(event:any){
  //    if(!this.manuallyAddedValue){
  //    this.manuallyAddedValue = event.target.value;
  //    }
    
 // }
  ShareLayout() {
    //this.Users.forEach(enteredValue => {
     // if(enteredValue.UPN) {
         //this.isValidEmailId = true;
         this.layoutName = this.selectedCustomTemplate + ' (shared)';
         this.saveAllMappingDetails(false, true);
     //}
     //else {
      //   this.isValidEmailId = false;
      //   return;
      // }
    // }
    // else {
    //   this.isValidEmailId = false;
    //   return;
    // }
   //});
  }
  // validateEmail(event: any) {
  //   this.isValidEmailId = (event.value.UPN.endsWith('@ey.com') || event.value.UPN.endsWith('@parthenon.ey.com')) ? true : false;
  // }
}

